export default __webpack_public_path__ + "static/media/fd5911183011d74b52fa22995767ec9a1581620121823.3c8ff8fd.webp";